var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextInputField',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder || _vm.$t('general.search'),"disabled":_vm.disabled,"loading":_vm.loading,"icon-left":"icon-search"},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }